import get from "lodash.get";
import { localStorageGet } from "../../../helpers/localStorage";
import { SESSION_TOKEN_LOCAL_STORAGE_KEY } from "../auth";

// Gets a fresh logged in state. Useful for absolute values
export const checkLoggedIn = () => !!get(localStorageGet(SESSION_TOKEN_LOCAL_STORAGE_KEY), 'access_token');
